







































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';

const cssPrefix = 'alert-setting';
@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwToggle,
    SwButton,
  },
})
export default class AlertSettings extends SwExtendedVue {
  cssPrefix = cssPrefix;
  notiPrefList: any = [];
  tempNotiPrefList: any = [];
  emailSubList: any = [];
  @Prop()
  notificationPreference: any;

  @Prop()
  emailSubscription: any;

  created() {
    this.setNotiPrefList();
    this.emailSubList = this.emailSubscription;
  }
  setNotiPrefList() {
    this.notiPrefList = this.notificationPreference.map((notification: any) => {
      return {
        notificationPrefText: notification.notificationPrefText,
        inapp: notification.notificationPrefChoiceId === '2' || notification.notificationPrefChoiceId === '1' ? true : false,
        emailInApp: notification.notificationPrefChoiceId === '2' ? true : false,
        notificationTypeID: notification.notificationTypeID,
      };
    });
    this.tempNotiPrefList = this.notiPrefList;
  }
  onInAppPrefChange(appNoti: any) {
    this.notiPrefList = this.tempNotiPrefList.map((notify: any) => {
      if (notify.notificationTypeID === appNoti.notificationTypeID) {
        if (appNoti.inapp === false) {
          notify.inapp = false;
          notify.emailInApp = false;
        } else {
          notify.inapp = true;
        }
        return notify;
      } else { // tslint:disable-line
        return notify;
      }
    });
  }
  onEmailInAppPrefChange(emailNoti: any) {
    this.notiPrefList = this.tempNotiPrefList.map((notify: any) => {
      if (notify.notificationTypeID === emailNoti.notificationTypeID) {
        if (emailNoti.emailInApp === false) {
          notify.inapp = false;
          notify.emailInApp = false;
        } else {
          notify.emailInApp = true;
          notify.inapp = true;
        }
        return notify;
      } else { // tslint:disable-line
        return notify;
      }
    });
  }
  confirmNotification() {
    const modifiedNotiPref = this.notificationPreference;
    this.notiPrefList.forEach((element: any, index: any) => {
      if (element.emailInApp) modifiedNotiPref[index].notificationPrefChoiceId = '2';
      else if (element.inapp) modifiedNotiPref[index].notificationPrefChoiceId = '1';
      else modifiedNotiPref[index].notificationPrefChoiceId = '0';
    });
    const request = {
      notificationpref: modifiedNotiPref,
    };
    this.$store.dispatch('MswAlertModule/updateNotificationPrefs', request)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
      }
    });
  }
  confirmEmailSub() {
    const request = {
      EmailSubscriptionList : this.emailSubList,
    };
    this.$store.dispatch('MswAlertModule/updateEmailPreference', request)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:SUCCESS') this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      else this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
    });
  }
}
